import { todayStr } from "../lib/date";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { getRiskCurrentWeek } from "../lib/api";

export default function RiskAssessmentReminder() {
  const navigate = useNavigate();
  const [state, setState] = useState(null);

  useEffect(() => {
    let mounted = true;
    getRiskCurrentWeek()
      .then((res) => { if (mounted) setState(res.data); })
      .catch(() => { /* silently skip — widget just won't render */ });
    return () => { mounted = false; };
  }, []);

  if (!state) return null;
  if (state.no_school_week) return null;
  const today = todayStr();
  // Only nag once we've reached the anchor day; submit any time afterwards is still fine
  if (state.week > today) return null;
  if (state.my_submission) return null;

  return (
    <Card className="border-amber-200 bg-amber-50" data-testid="risk-assessment-reminder">
      <CardContent className="p-4 flex items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#b45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-amber-900">Weekly Risk Assessment Due</div>
          <div className="text-sm text-amber-800">
            Please submit your overall vibe-check for the week ending {state.week}.
          </div>
        </div>
        <Button onClick={() => navigate("/reports?tab=risk-assessment")} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="risk-reminder-cta">
          Submit Now
        </Button>
      </CardContent>
    </Card>
  );
}
